import { render, staticRenderFns } from "./ConfirmTaxSavings.vue?vue&type=template&id=8620954c"
import script from "./ConfirmTaxSavings.vue?vue&type=script&lang=js"
export * from "./ConfirmTaxSavings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports